import { useEffect } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import type { InspectionTemplate, TemplateSection } from 'inspection-types';

type Params = {
  template: InspectionTemplate | undefined;
  sortedSections: TemplateSection[];
  setExpandedBySectionId: Dispatch<
    SetStateAction<Record<string, boolean>>
  >;
  setActiveSectionId: Dispatch<SetStateAction<string | null>>;
};

export function useInspectionTemplateCustomizeExpandedState({
  template,
  sortedSections,
  setExpandedBySectionId,
  setActiveSectionId,
}: Params): void {
  useEffect(() => {
    if (!template || sortedSections.length === 0) {
      return;
    }

    const next: Record<string, boolean> = {};

    for (const section of sortedSections) {
      next[section.id] = !section.config?.collapsedByDefault;
    }

    setExpandedBySectionId(next);

    if (sortedSections[0]) {
      setActiveSectionId(sortedSections[0].id);
    }
  }, [template, sortedSections, setExpandedBySectionId, setActiveSectionId]);
}
